/**
 * The seed URL field grows beside the add button, and stops at this width.
 * A fixed width hid long URLs while they were being typed.
 */
export const SEED_URL_FIELD_LAYOUT = {
	maxWidth: '600px'
} as const;
